import { Component, ChangeDetectionStrategy, Input, EventEmitter, Output, OnDestroy, OnInit } from '@angular/core';

import { DomManipulateService } from '@app/modules/core/services/dom-manipulate.service';

@Component({
  selector: 'app-side-bar',
  templateUrl: './side-bar.component.html',
  styleUrls: ['./side-bar.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class SideBarComponent implements OnInit, OnDestroy {

  @Input() manipulateDOM = true;
  @Input() showHeader = false;

  @Input() title: string;
  @Input() subTitle: string;

  @Output() toggleModal: EventEmitter<void> = new EventEmitter<void>();

  public fadeOut = false;

  constructor(
    private readonly domManipulateService: DomManipulateService
  ) { }

  ngOnInit(): void {
    if (this.manipulateDOM) {
      this.domManipulateService.setBodyScroll(false);
    }
  }

  ngOnDestroy(): void {
    if (this.manipulateDOM) {
      this.domManipulateService.setBodyScroll(true);
    }
  }

  get showSubTitle(): boolean {
    return !!this.subTitle && this.subTitle.length > 0;
  }

}
